"use strict";

import Swiper from "swiper";
import { EffectFade } from "swiper/modules";

document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll(".hero-slider").forEach((slider) => {
        const swiper = new Swiper(slider, {
            modules: [EffectFade],
            effect: "fade",
            fadeEffect: {
                crossFade: true
            },
            slidesPerView: 1,
            loop: true,
            speed: 1200,
            allowTouchMove: false,
            simulateTouch: false
        });
        function runSlide() {
            swiper.slides.forEach(slide => {
                slide.classList.remove("anim1", "anim2");
            });
            const current = swiper.slides[swiper.activeIndex];
            current.classList.add("anim1");
            setTimeout(() => {
                swiper.slideNext();
                const next = swiper.slides[swiper.activeIndex];
                setTimeout(() => {
                    next.classList.add("anim2");
                }, 1000);
            }, 1000);
        }
        setTimeout(() => {
            swiper.slides[swiper.activeIndex].classList.add("anim2");
        }, 1000);
        setInterval(runSlide, 6000);
    });
});